module.exports = __webpack_public_path__ + "img/24.f50c834e.png";